const tabName = ["insidePhoto", "outsidePhoto", "video", "upgradeOptions"];

const scrollByOptions = {
  top: 325,
  left: 0,
  behavior: "smooth",
};

export { tabName, scrollByOptions };
